<template>
    <div>
        <h3 class="is-size-3">INEGI Geoestadisticas</h3>
        <p>
            <code>POST {{ host }}/api/inegiLocations</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene dos parámetros:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>stateCode</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato (Ej. 08)</li>
                    </ul>
                </li>
                <li>
                    <strong>locationName</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. Chihuahua)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
            {
                "stateCode": "08",
                "locationName": "Chihuahua"
            }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            [
                {
                    "geoCode": "080040019",
                    "stateCode": "08",
                    "muncipalityCode": "004",
                    "locationCode": "0019",
                    "locationName": "Chihuahua Viejo",
                    "locationType": "RURAL",
                    "latitud": "28.5768669",
                    "longitud": "-105.8200203",
                    "altitud": "1531",
                    "population": 0,
                    "household": 0
                },
                {
                    "geoCode": "080050074",
                    "stateCode": "08",
                    "muncipalityCode": "005",
                    "locationCode": "0074",
                    "locationName": "Rincón de Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "30.8477306",
                    "longitud": "-107.3223689",
                    "altitud": "1219",
                    "population": 1,
                    "household": 1
                },
                {
                    "geoCode": "080111082",
                    "stateCode": "08",
                    "muncipalityCode": "011",
                    "locationCode": "1082",
                    "locationName": "Las Brujas de Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "27.7124528",
                    "longitud": "-105.1900811",
                    "altitud": "1211",
                    "population": 6,
                    "household": 1
                },
                {
                    "geoCode": "080130386",
                    "stateCode": "08",
                    "muncipalityCode": "013",
                    "locationCode": "0386",
                    "locationName": "Saucito Chihuahua [Rancho]",
                    "locationType": "RURAL",
                    "latitud": "30.0425506",
                    "longitud": "-108.4520275",
                    "altitud": "1769",
                    "population": 0,
                    "household": 0
                },
                {
                    "geoCode": "080190001",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "0001",
                    "locationName": "Chihuahua",
                    "locationType": "URBANO",
                    "latitud": "28.6367939",
                    "longitud": "-106.0763067",
                    "altitud": "1424",
                    "population": 925762,
                    "household": 296779
                },
                {
                    "geoCode": "080191038",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "1038",
                    "locationName": "La Puerta de Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "28.5908147",
                    "longitud": "-105.9590092",
                    "altitud": "1477",
                    "population": 0,
                    "household": 0
                },
                {
                    "geoCode": "080191287",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "1287",
                    "locationName": "Productos Hortícolas de Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "28.8678117",
                    "longitud": "-106.2213742",
                    "altitud": "1564",
                    "population": 0,
                    "household": 0
                },
                {
                    "geoCode": "080191233",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "1233",
                    "locationName": "Granjas Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "28.5682064",
                    "longitud": "-106.0244872",
                    "altitud": "1521",
                    "population": 71,
                    "household": 20
                },
                {
                    "geoCode": "080190915",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "0915",
                    "locationName": "Fraccionamiento Presa Chihuahua",
                    "locationType": "RURAL",
                    "latitud": "28.5563631",
                    "longitud": "-106.1707017",
                    "altitud": "1550",
                    "population": 0,
                    "household": 0
                },
                {
                    "geoCode": "080440193",
                    "stateCode": "08",
                    "muncipalityCode": "044",
                    "locationCode": "0193",
                    "locationName": "Ninguno [Productos Hidropónicos de Chihuahua]",
                    "locationType": "RURAL",
                    "latitud": "26.8356528",
                    "longitud": "-105.6073278",
                    "altitud": "1725",
                    "population": 0,
                    "household": 0
                }
            ]
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>